import { render } from "./MiSwitch.vue?vue&type=template&id=48ddc2ed&scoped=true"
import script from "./MiSwitch.vue?vue&type=script&lang=js"
export * from "./MiSwitch.vue?vue&type=script&lang=js"

import "./MiSwitch.vue?vue&type=style&index=0&id=48ddc2ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ddc2ed"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
